import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=5147627f&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"
import style0 from "./stats.vue?vue&type=style&index=0&id=5147627f&prod&scoped=true&lang=css"
import style1 from "@/css/oom.css?vue&type=style&index=1&id=5147627f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147627f",
  null
  
)

export default component.exports